import React from "react";
import styles from "./NavigationMenu.module.scss";
import RenderIf from "@/components/Global/RenderIf/RenderIf";
import {MyAccountNavigation} from "./Variants";

export default function NavigationMenu({variant}) {
  return (
    <nav className={styles.navigationWrapper}>
      <RenderIf isTrue={variant === "MyAccount"}>
        <MyAccountNavigation />
      </RenderIf>
    </nav>
  );
}
